import React, { createRef, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import * as R from "ramda";
import { useDispatch, useSelector } from 'react-redux';
import { Document, Page, pdfjs } from 'react-pdf';
import { getLetterInformationByLetterId } from '../../../actions/facilita-api';
import { unvalidateLetter } from '../../../actions/backoffice/user';
import { FrenchTypes, PensionProfessionalCategoryMapping } from '../../../constants/utils/connectionTypes';
import { LetterProgressStage } from '../../../constants/utils/letterProgressStage';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const PreviewDocLetter = ({ setSelectedUserLetter, serviceDataLetters, documentUrl, selectedServices, serviceLetter, setServiceLetter, setSelectedUserService, selectedUserService, selectedUserLetter }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const hideModal = () => {
        $('.modal').modal("hide");
    };


    const [numPages, setNumPages] = useState(0);
    const [elementOnFocus, setElementOnFocus] = useState(0);
    const [elRefs, setElRefs] = useState([]);
    const [isUnvalidatingLetterId, setIsUnvalidatingLetterId] = useState(null);

    useEffect(() => {
        // setServiceLetter(lettersOfChosenService);
        // setServiceLetter()

        if (!R.isNil(selectedServices)) {

            let lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === selectedUserService.id);

            let promises = [];
            lettersOfChosenService.forEach((l) => {
                promises.push(getLetterInformationByLetterId(l.letterId));
            });

            Promise.all(promises)
                .then((letters) => {

                    lettersOfChosenService = lettersOfChosenService.map(letterService => {
                        let letter = letters.find(l => letterService.letterId === l.id);
                        if (!R.isNil(letter)) {
                            letterService.name = letter.name.split("-").slice(1).join();
                        }
                        return letterService;
                    });

                    setServiceLetter(lettersOfChosenService);
                    setSelectedUserLetter(lettersOfChosenService[0]);
                });


            setElRefs(elRefs => (
                selectedServices.map((_, i) => createRef())
            ));

        }

    }, [selectedUserService, selectedServices]);



    return (
        <div className="modal fade px-0" id="previewDoc" aria-labelledby="validationLabel" aria-hidden="true">
            <div className="modal-dialog px-2 modal-dialog-scrollable container-modal">
                <div className="modal-content bg-light">
                    <div className="modal-header pb-0" data-dismiss="modal" aria-label="Close">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h5 className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="validationLabel">Validation des documents</h5>
                        </div>
                    </div>
                    <div className="modal-body pb-0 scroll-default">
                        <div className="row grid-sm grid-lg-2 align-items-center gx-3 grid-auto-scroll">
                            <div className="col-12 col-lg">
                                <div className="block mx-auto container-lg-copy">
                                    <Document className="border-0 h-wide" file={documentUrl} loading={<div style={{ width: "500px" }}><p>Chargement...</p></div>}
                                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                                        {Array.apply(null, Array(numPages))
                                            .map((x, i) => i + 1)
                                            .map(page => <Page pageNumber={page} width={500} loading={<div style={{ width: "500px" }}><p>Chargement...</p></div>} key={"pdfviewer_page_" + page} className={"card paper-shadow mb-2 mx-auto align-items-center"} />)}
                                    </Document>
                                </div>
                            </div>
                            <div className="col-12 col-lg h-100 pr-lg-3 order-first order-lg-last">
                                <div className="accordion" id="accordionOptions">
                                    <div className="flex-row align-items-center sticky-auto t-auto-0 z-2 bg-light">
                                        {!R.isNil(selectedServices) && selectedServices.length > 1 && (elementOnFocus > 0) ?
                                            <button className="btn btn-icon btn-faded btn-square o-50 o-100--hover mr-2 d-none d-xl-unset" onClick={() => {
                                                let elemenetToFocus = elementOnFocus;
                                                if (elementOnFocus > 0) {
                                                    elemenetToFocus = elementOnFocus - 1;
                                                }
                                                if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
                                                    elRefs[elemenetToFocus].current.scrollIntoView({ behavior: 'smooth' });
                                                    elRefs[elemenetToFocus].current.click();
                                                }
                                                setElementOnFocus(elemenetToFocus);
                                            }}><i className="eva eva-arrow-ios-back-outline align-middle h4 lh-solid m-auto"></i></button>
                                            : ''
                                        }
                                        <div className="scroller-nav sticky-top bg-light">
                                            <nav className="nav py-2 flex-row align-items-center">
                                                {/* <button className="btn btn-outline-primary rounded-max py-2 px-sm mr-1" >name</button> */}
                                                {

                                                    selectedServices && selectedServices.map((service, index) => {
                                                        let name = service.serviceName;
                                                        if (service.serviceType === FrenchTypes.activity) {
                                                            name = service.payload.companyName;
                                                        } else if (service.serviceType === FrenchTypes.otherActivity) {
                                                            name = service.payload.name;
                                                        } else if (service.serviceType === FrenchTypes.pension) {
                                                            let categories = Object.values(PensionProfessionalCategoryMapping[0].options).concat(
                                                                Object.values(PensionProfessionalCategoryMapping[1].options)
                                                            ).concat(
                                                                Object.values(PensionProfessionalCategoryMapping[2].options)
                                                            ).concat(
                                                                Object.values(PensionProfessionalCategoryMapping[3].options)
                                                            );
                                                            name = categories.find(c => c.value === service.payload.professionalCategory).title;
                                                        } else if (service.serviceType === FrenchTypes.socialSecurity) {
                                                            name = "CPAM";
                                                        }

                                                        if (service.serviceId.startsWith('Custom')) {
                                                            name = service.customServiceDetails.name;
                                                        }

                                                        return (<button className={"btn btn-outline-primary rounded-max py-2 px-sm mr-1" + (selectedUserService.id === service.id ? " active" : "")} key={"service_" + index} ref={elRefs[index]} onClick={() => {
                                                            //const lettersOfChosenService = serviceDataLetters.filter(srvData => srvData.userServiceId === service.id);
                                                            //setServiceLetter(lettersOfChosenService);
                                                            setElementOnFocus(selectedServices.indexOf(service));
                                                            setSelectedUserService(service);
                                                        }}>{name}</button>);
                                                    })
                                                }
                                            </nav>
                                        </div>
                                        {!R.isNil(selectedServices) && selectedServices.length > 1 && elementOnFocus < selectedServices.length - 1 ?
                                            <button className={"btn btn-icon btn-faded btn-square o-50 o-100--hover ml-2"} onClick={() => {
                                                let elemenetToFocus = elementOnFocus;
                                                if (elementOnFocus < selectedServices.length - 1) {
                                                    elemenetToFocus = elemenetToFocus + 1;
                                                }
                                                if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
                                                    elRefs[elemenetToFocus].current.scrollIntoView({ behavior: 'smooth' });
                                                    elRefs[elemenetToFocus].current.click();
                                                }
                                                setElementOnFocus(elemenetToFocus);

                                            }}><i className="eva eva-arrow-ios-forward-outline align-middle h4 lh-solid m-auto"></i></button>
                                            : ''
                                        }
                                    </div>

                                    {
                                        false ?
                                            <p>CHARGEMENT</p>
                                            :
                                            ''
                                    }


                                    {
                                        !R.isNil(serviceLetter) && serviceLetter.map((letter, index) => {
                                            return (
                                                <div className="card ml-nborder bg-none mt-3" key={"letter_" + letter.id} onClick={() => setSelectedUserLetter(letter)}>
                                                    <div className="card-header py-0 pr-0 pl-gutter" id="headingOption3" role="button" >
                                                        <div className="flex-row align-items-center">
                                                            <h2 className="h4 font-weight-demi my-auto ml-border mr-1">
                                                                <i className={"btn p-border rounded-sm eva eva-arrow-ios-back-outline fs-4 align-middle mr-2 ml-ngutter" + (selectedUserLetter?.id === letter.id ? " text-primary bg-white" : " o-40")}></i>
                                                                <span className="align-middle">{letter.name}</span>
                                                            </h2>
                                                            {/* <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button> */}
                                                        </div>
                                                        <hr className="mt-2 mb-0 border-gray" />


                                                        <div className="card mb-3">
                                                            <div className="card-body">
                                                                <div className="flex-column flex-md-row mb-3 mb-md-2 text-right">
                                                                    <h5 className="h3 font-weight-bolder my-auto mr-2">Chronologie</h5>
                                                                    {
                                                                        R.isNil(letter.postId) ? 
                                                                            ''
                                                                        :
                                                                            <p className="fs-3 my-auto ml-md-auto lh-title"><span className="fs-2 lh-1 o-60">Numéro suivi postal: </span><br />{letter.postId}</p>
                                                                    }
                                                                    {
                                                                        letter.letterProgressStage === "Validated" && !R.isNil(user.user) && user.user.email === "roger.tager@connectlime.com" ?
                                                                            <button 
                                                                                type="button" 
                                                                                className={"btn btn-sm btn-icon px-xs btn-alert-danger border-none rounded loading-btn" + (isUnvalidatingLetterId === letter.id ? " show" : "")}
                                                                                title="Annuler validation"
                                                                                disabled={isUnvalidatingLetterId === letter.id}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    setIsUnvalidatingLetterId(letter.id);
                                                                                    dispatch(unvalidateLetter(letter))
                                                                                        .then(() => {
                                                                                            // Fetch the updated letter from backend
                                                                                            getLetterInformationByLetterId(letter.letterId)
                                                                                                .then(() => {
                                                                                                    // Reload page to refresh all data
                                                                                                    window.location.reload();
                                                                                                })
                                                                                                .catch(() => {
                                                                                                    setIsUnvalidatingLetterId(null);
                                                                                                });
                                                                                        })
                                                                                        .catch(() => {
                                                                                            setIsUnvalidatingLetterId(null);
                                                                                        });
                                                                                }}>
                                                                                <i className="eva eva-undo-outline"></i>
                                                                                <span className="ml-1">Annuler validation</span>
                                                                                <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                                                            </button>
                                                                        : ''
                                                                    }
                                                                </div>
                                                                <hr />
                                                                {/* <p className="lead lh-title mb-auto"><i className={"eva eva-radio-button-on mr-1 align-middle" + ((false) ? ' text-gray' : ' text-success')}></i><span className={"fs-3 align-middle" + ((false) ? ' o-60' : '')}>history.date.substring</span></p> */}
                                                                {!R.isNil(letter.letterHistory) && letter.letterHistory.map((history, index) => {
                                                                    return (<p className="lead lh-title mb-auto" key={"history_" + index}><i className={"eva eva-radio-button-on mr-1 align-middle" + ((index < letter.letterHistory.length - 1) ? ' text-gray' : ' text-success')}></i><span className={"fs-3 align-middle" + ((index < letter.letterHistory.length - 1) ? ' o-60' : '')}>{history.date.substring(0, 10)}: {LetterProgressStage[history.letterProgressStage]} {!R.isNil(history.details) && history.details !== "" ? `(${history.details})` : ''}</span></p>);
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer py-3">
                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    );
};